import {h, Fragment} from "preact"
import { useEffect, useRef } from "preact/hooks";

export default function CollectionSearchLogic({categoryPath}) {
  const inputRef = useRef(null);


  useEffect(() => {
    const input = inputRef.current;
    if (!input) return;
  
    const style = document.createElement("style");
    style.textContent = `
      #nosto-disruptor-tile:first-child:not(.moved) {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  
    const curUrl = window.location.search;
    const curUrlParams = new URLSearchParams(curUrl);
    const curQuery = curUrlParams.get("q");
    let curQueryString = "";
    if (curQuery) {
      curQueryString = curQuery.replace("+", " ");
      input.value = curQueryString;
      input.focus();
    }
  
    let debounceTimer;
  
    function updateUrlParams(query) {
      const url = new URL(window.location.href);
  
      // Clone before dispatching event
      const disruptorTile = document.querySelector("#nosto-disruptor-tile");
      let disruptorClone = null;
      if (disruptorTile) {
        disruptorClone = disruptorTile.cloneNode(true);
      }
  
      if (query) {
        url.searchParams.set("q", query);
        input.value = query;
      } else {
        url.searchParams.delete("q");
      }
  
      window.history.replaceState({}, "", url.toString());
      window.dispatchEvent(new PopStateEvent("popstate"));
  
      if (disruptorClone) {
        const productList = document.querySelector(".ns-serp-inner .product-list");
        if (!productList) return;
  
        const existingTiles = productList.querySelectorAll("#nosto-disruptor-tile");
        existingTiles.forEach(tile => tile.remove());
  
        const observer = new MutationObserver(() => {
          const children = productList.children;
          if (children.length > 0) {
            if (children.length >= 6) {
              productList.insertBefore(disruptorClone, children[6]);
            } else {
              productList.appendChild(disruptorClone);
            }
            observer.disconnect();
          }
        });
  
        observer.observe(productList, { childList: true });
      }
    }
  
    function onInput() {
      const query = input.value.trim();
  
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        updateUrlParams(query);
      }, 500);
    }
  
    input.addEventListener("input", onInput);
  
    return () => {
      input.removeEventListener("input", onInput);
      if (debounceTimer) clearTimeout(debounceTimer);
      if (style) style.remove();
    };
  }, []);

  return (
    <div class="collection-search__container">
      <div class="collection-search__bar">
        <form
          class="collection-search__form"
          autocomplete="off"
          onSubmit={(e) => e.preventDefault()}
        >
          <div class="collection-search__input-container">
            <input
              ref={inputRef}
              class="collection-search__input"
              type="text"
              autocomplete="off"
              placeholder={`Search within ${categoryPath ? categoryPath: "this collection"}`}
              aria-label="Search Collection"
            />
          </div>
          <button
            class="collection-search__button button notabutton"
            type="submit"
            aria-label="Submit"
          >
            <svg viewBox="0 0 19 21" fill="currentColor">
              <g transform="translate(0,0.472222)">
                <path d="M14.3977778,14.0103889 L19,19.0422222 L17.8135556,20.0555556 L13.224,15.0385 C11.8019062,16.0671405 10.0908414,16.619514 8.33572222,16.6165556 C3.73244444,16.6165556 0,12.8967778 0,8.30722222 C0,3.71766667 3.73244444,0 8.33572222,0 C12.939,0 16.6714444,3.71977778 16.6714444,8.30722222 C16.6739657,10.4296993 15.859848,12.4717967 14.3977778,14.0103889 Z M8.33572222,15.0585556 C12.0766111,15.0585556 15.1081667,12.0365 15.1081667,8.30827778 C15.1081667,4.58005556 12.0766111,1.558 8.33572222,1.558 C4.59483333,1.558 1.56327778,4.58005556 1.56327778,8.30827778 C1.56327778,12.0365 4.59483333,15.0585556 8.33572222,15.0585556 Z"></path>
              </g>
            </svg>
          </button>
        </form>
      </div>
    </div>
  );
}
